import { render, staticRenderFns } from "./EditOppoStaff.vue?vue&type=template&id=ccce9232&scoped=true&"
import script from "./EditOppoStaff.vue?vue&type=script&lang=js&"
export * from "./EditOppoStaff.vue?vue&type=script&lang=js&"
import style0 from "./EditOppoStaff.vue?vue&type=style&index=0&id=ccce9232&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccce9232",
  null
  
)

export default component.exports